import { parseJson } from './json';

export const getToken = (): TOKEN.Auth => {
  const data = localStorage.getItem('auth_tconnect');
  const auth = parseJson<TOKEN.Auth>(data);
  return auth;
};

export const setToken = (t: TOKEN.Auth) => {
  localStorage.setItem('auth_tconnect', JSON.stringify(t));
};

export const logoutToken = () => {
  localStorage.removeItem('auth_tconnect');
};
